finderApp.directive('niLazyLoad', function() {
    return {
        scope: {
            niLazyLoad: '=',
            niLL: '&'
        },
        link: function(scope, element, attr) {
            jQuery(element).responsiveLazyLoader();

            scope.$watch('niLazyLoad', function(url) {
                jQuery(element)
                    .removeClass('loaded')
                    .removeAttr('data-current-mediaq')
                    .removeAttr('data-display')
                    .css('background-image', 'none')
                    .attr('data-src-ll', url)
                    .data('plugin_responsiveLazyLoader')
                    .refresh();
                jQuery(window).trigger('resize');
            });

        }
    };
});